module.exports = __webpack_public_path__ + "img/t4-c3.7c93468d.png";